import { HpHandlers } from './getPaymentStatusAction';
import { FullPolicyData } from 'interfaces/customerDataTypes';
import { HP_MESSAGE_TYPE, HpPaymentOutcomeMessageData } from 'interfaces/messageTypes';
import { AUDIT_TYPE } from 'interfaces/auditTypes';
import { sendAuditEvent } from 'utils';
import { renewPolicyAction } from './renewPolicyAction';

interface GetRenewalPaymentHandlerProps {
  selectedPolicy: FullPolicyData;
  policyDetailsId: string;
  historyId: number;
  email: string;
  isAgent: boolean;
}

export function getRenewalPaymentHandler({
  selectedPolicy,
  policyDetailsId,
  historyId,
  email,
  isAgent
}: GetRenewalPaymentHandlerProps): HpHandlers {
  return {
    [HP_MESSAGE_TYPE.PAYMENT_OUTCOME]: (ctx) => {
      const { dispatch, data } = ctx;

      const {
        paymentReference,
        paymentStatus,
        success,
        cardLastFour,
        cardType,
        cardImageUrl,
        expiryDate,
        transactionReference
      } = data as HpPaymentOutcomeMessageData;

      const { policyNumber } = selectedPolicy;

      if (success) {
        dispatch({
          type: 'PAYMENT_SUCCESS',
          payload: { paymentReference, cardLastFour, cardType, cardImageUrl, expiryDate }
        });
        sendAuditEvent({
          activityId: AUDIT_TYPE.PAYMENT_SUCCESS_MESSAGE_RECEIVED,
          policyDetailsId,
          historyId,
          policyNumber
        });

        dispatch(
          // @ts-expect-error dispatching an action creator rather than an action
          renewPolicyAction({
            username: email,
            isAgent,
            paymentPreference: 'yearly',
            paymentReference,
            transactionReference,
            policyDetailsId,
            historyId
          })
        );
      } else {
        dispatch({ type: 'PAYMENT_ERROR', payload: paymentStatus });
        sendAuditEvent({
          activityId: AUDIT_TYPE.PAYMENT_FAILURE_MESSAGE_RECEIVED,
          policyDetailsId,
          historyId,
          policyNumber
        });
      }
    }
  };
}
